// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__hA7TG","wrapper":"Loader_wrapper__3HBLV"};